import React from 'react'
import { motion } from 'framer-motion'
import { Section } from './ui'
import { cn } from '../utils'

const WhySection: React.FC = () => {
  return (
    <Section id="why" background="default" padding="xl">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="text-xs font-medium tracking-[0.22em] uppercase text-primary-600 dark:text-primary-300 mb-4">
            Why MATNO
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-gray-900 dark:text-white leading-tight mb-8">
            Bridging the gap between{' '}
            <span className="text-primary-500 dark:text-primary-300">insight</span> and{' '}
            <span className="text-secondary-500 dark:text-secondary-300">implementation</span>.
          </h2>

          <div className="space-y-5 text-lg text-gray-600 dark:text-gray-300 leading-relaxed">
            <p>
              Africa does not lack ideas, talent, or ambition. The challenge is turning
              knowledge into systems, data into decisions, and innovation into impact.
            </p>
            <p>
              MATNO bridges research, policy, technology, and implementation to help
              African institutions design and deliver transformation that works — grounded
              in local realities and built with the people who will use it.
            </p>
          </div>

          {/* Three-point summary */}
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              { label: 'Knowledge', value: 'Turned into systems' },
              { label: 'Data',      value: 'Turned into decisions' },
              { label: 'Innovation', value: 'Turned into impact' },
            ].map(item => (
              <div
                key={item.label}
                className={cn(
                  'relative pl-4 border-l-2 border-primary-400 dark:border-primary-500'
                )}
              >
                <p className="text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-400 mb-1">
                  {item.label}
                </p>
                <p className="text-base font-medium text-gray-900 dark:text-white">
                  {item.value}
                </p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </Section>
  )
}

export default WhySection
